import { Action } from 'redux';

import { OpenCancelFlowRunDialog } from '~src/bootstrap/redux/actions/AppActionTypes';

import { FlowOutputStepRunListItemInfo } from '../models/FlowOutputStepRunInfo';

export interface OpenCancelFlowRunDialogAction extends Action {
  outputStepRun: FlowOutputStepRunListItemInfo;
}

export function openCancelFlowRunDialogAction(outputStepRun: FlowOutputStepRunListItemInfo): OpenCancelFlowRunDialogAction {
  return {
    type: OpenCancelFlowRunDialog,
    outputStepRun,
  };
}
